let columns = [
  { label: '最大值', field: 'value1' },
  { label: '最小值', field: 'value2' },
  { label: '平均值', field: 'value3' },
]
let pieDict = { 最大值: "value1", 最小值: "value2", 平均值: "value3" }

let arr = [
  { label: "地块编号", field: "landNo" },
  { label: "权属单位", field: "villageName" },
  { label: "地块面积（亩）", field: "area", num: 2 },
  { label: "土壤类型", field: "soilType" },
  { label: "耕地质量等级", field: "landQualityCn" },
  { label: "作物类型", field: "cropType" },
  { label: "土壤有机质(g/kg)", field: "organicMatter", num: 2 },
  { label: "土壤pH值", field: "ph" },
  { label: "土壤全氮(g/kg)", field: "nitrogen", num: 2 },
  { label: "土壤有效磷(mg/kg)", field: "phosphorus", num: 2 },
  { label: "土壤速效钾(mg/kg)", field: "potassium", num: 2 },
];
export default {
  'landManage': {
    // 标题
    title: '地块管理',
    rollerShow:false,
    introductionShow:true,
    datePickerShow:false,
    numLandLayerShow:true,
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: [
      { label: '地块编号', field: 'landNo' },
      { label: '权属单位', field: 'villageName' },
      { label: '地块面积（亩）', field: 'area' },
      { label: '土壤类型', field: 'soilType' },
      { label: '耕地质量等级', field: 'landQualityCn' },
      { label: '作物类型', field: 'cropType' },
      { label: '土壤有机质(g/kg)', field: 'organicMatter' },
      { label: '土壤pH值', field: 'ph' },
      { label: '土壤全氮(g/kg)', field: 'nitrogen' },
      { label: '土壤有效磷(mg/kg)', field: 'phosphorus' },
      { label: '土壤速效钾(mg/kg)', field: 'potassium' },
    ],
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: 'getOpt2'
  },
  'nonFarm': {
    // 标题
    title: '非粮监测',
    rollerShow:true,
    LandLayerShow:true,
    datePickerShow:true,
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: [
      { label: '粮食作物（亩）', field: 'value1' },
      { label: '非粮食作物（亩）', field: 'value2' },
    ],
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: 'getOpt3',
    echart2: 'getOpt2'
  },
  'cropDistribution': {
    rollerShow:true,
    LandLayerShow:true,
    datePickerShow:true,
    // 标题
    title: '作物分布',
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: [
      { label: '粮食作物', field: 'value1' },
      { label: '非粮食作物', field: 'value2' },
    ],
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: 'getOpt3',
    echart2: 'getOpt2'
  },

  'landSoil': {
    rollerShow:true,
    LandLayerShow:true,
    datePickerShow:true,
    cropSelectShow:true,
    // 标题
    title: '苗情监测',
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: [
      { label: '一类苗（亩）', field: 'value1' },
      { label: '二类苗（亩）', field: 'value2' },
      { label: '三类苗（亩）', field: 'value3' },
    ],
    pieDict: pieDict,
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: 'getOpt3',
    echart2: 'getOpt2',
    legendType: 'legend',
    datasetUnit: ''
  },
  'landLai': {
    // 标题
    title: '叶面积指数',
    rollerShow:true,
    LandLayerShow:true,
    datePickerShow:true,
    cropSelectShow:true,
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: columns,
    pieDict: pieDict,
    datasetUnit: '',
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: 'getOpt3',
    echart2: 'getOpt2',
    colorList: [
      {
        labelText: '0.0',
        color: "#feff90",
      },
      {
        labelText: '0.25',
        color: "#a2f24c",
      },
      {
        labelText: '0.5',
        color: "#3ec949",
      },
      {
        labelText: '0.75',
        color: "#2079a3",
      },
      {
        labelText: '1.0',
        color: "#222381",
      },
    ]
  },
  'landQualityDan': {
    // 标题
    title: '植株氮含量',
    rollerShow:true,
    LandLayerShow:true,
    datePickerShow:true,
    cropSelectShow:true,
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: [
      { label: '最大值(g/kg)', field: 'value1' },
      { label: '最小值(g/kg)', field: 'value2' },
      { label: '平均值(g/kg)', field: 'value3' },
    ],
    pieDict: pieDict,
    datasetUnit: 'g/kg',
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: 'getOpt3',
    echart2: 'getOpt2',
    colorList: [
      {
        labelText: '0.0',
        color: "#4f2094",
      },
      {
        labelText: '0.25',
        color: "#a37fad",
      },
      {
        labelText: '0.5',
        color: "#ecf5b0",
      },
      {
        labelText: '0.75',
        color: "#6bad4b",
      },
      {
        labelText: '1.0',
        color: "#187c0d",
      },
    ]
  },
  'landNdvi': {
    // 标题
    title: '归一化差异植被指数',
    rollerShow:true,
    LandLayerShow:true,
    datePickerShow:true,
    cropSelectShow:true,
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: columns,
    pieDict: pieDict,
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: 'getOpt3',
    echart2: 'getOpt2',
    datasetUnit: '',
    colorList: [
      {
        labelText: '0.0',
        color: "#0df503",
      },
      {
        labelText: '0.25',
        color: "#9df700",
      },
      {
        labelText: '0.5',
        color: "#f7e100",
      },
      {
        labelText: '0.75',
        color: "#fc6c00",
      },
      {
        labelText: '1.0',
        color: "#f50000",
      },
    ]
  },
  'landGci': {
    // 标题
    title: '绿色叶绿素植被指数',
    rollerShow:true,
    LandLayerShow:true,
    datePickerShow:true,
    cropSelectShow:true,
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: columns,
    datasetUnit: '',
    pieDict: pieDict,
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: 'getOpt3',
    echart2: 'getOpt2',
    colorList: [
      {
        labelText: '0.0',
        color: "#0df503",
      },
      {
        labelText: '0.25',
        color: "#9df700",
      },
      {
        labelText: '0.5',
        color: "#f7e100",
      },
      {
        labelText: '0.75',
        color: "#fc6c00",
      },
      {
        labelText: '1.0',
        color: "#f50000",
      },
    ]
  },

  landQualityDen: {
    // 标题
    title: "耕地质量等级",
    LandLayerShow:true,
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: arr,
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: "getOpt2",
    land_filed: 'land_quality',
    type: 'fixed',

    colorList: [
      {
        value: '1',
        labelText: '一等地',
        color: "rgb(56, 168, 0)",
      },
      {
        value: '2',
        labelText: '二等地',
        color: "rgb(90, 186, 0)",
      },
      {
        value: '3',
        labelText: '三等地',
        color: "rgb(131, 207, 0)",
      },
      {
        value: '4',
        labelText: '四等地',
        color: "rgb(176, 224, 0)",
      },
      {
        value: '5',
        labelText: '五等地',
        color: "rgb(228, 245, 0)",
      },
      {
        value: '6',
        labelText: '六等地',
        color: "rgb(255, 225, 0)",
      },
      {
        value: '7',
        labelText: '七等地',
        color: "rgb(255, 170, 0)",
      },
      {
        value: '8',
        labelText: '八等地',
        color: "rgb(255, 115, 0)",
      },
      {
        value: '9',
        labelText: '九等地',
        color: "rgb(255, 55, 0)",
      },
      {
        value: '10',
        labelText: '十等地',
        color: "rgb(255, 0, 0)",
      },
    ]
  },
  landQualityDan: {
    // 标题
    title: "土壤氮含量",
    LandLayerShow:true,
    sortDatasetName: "氮含量",
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: arr,
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: "getOpt2",
    datasetUnit: 'g/kg',
    land_filed: 'nitrogen',
    type: 'class',
    colorList: [
      {
        labelText: '1',
        color: "rgb(255,235,241)",
      },
      {
        labelText: "1",
        color: "rgb(255,217,228)",
      },
      {
        labelText: "1",
        color: "rgb(255,197,215)",
      },
      {
        labelText: "1",
        color: "rgb(255,173,199)",
      },
      {
        labelText: "1",
        color: "rgb(255,151,183)",
      },
      {
        labelText: "1",
        color: "rgb(255,129,168)",
      },
      {
        labelText: '1',
        color: "rgb(255,101,149)",
      },
    ]
  },
  landQualityLin: {
    // 标题
    title: "土壤有效磷",
    LandLayerShow:true,
    sortDatasetName: "有效磷",
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: arr,
    datasetUnit: 'mg/kg',
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: "getOpt2",
    land_filed: 'phosphorus',
    type: 'class',
    colorList: [
      {
        labelText: '1',
        color: "rgb(227,237,241)",
      },
      {
        labelText: "1",
        color: "rgb(198,220,228)",
      },
      {
        labelText: "1",
        color: "rgb(172,204,216)",
      },
      {
        labelText: "1",
        color: "rgb(143,187,203)",
      },
      {
        labelText: "1",
        color: "rgb(114,169,188)",
      },
      {
        labelText: "1",
        color: "rgb(83,149,173)",
      },
      {
        labelText: '1',
        color: "rgb(69,125,145)",
      },
    ]
  },
  landQualityJia: {
    // 标题
    title: "土壤速效钾",
    LandLayerShow:true,
    sortDatasetName: "速效钾",
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: arr,
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: "getOpt2",
    datasetUnit: 'mg/kg',
    land_filed: 'potassium',
    type: 'class',
    colorList: [
      {
        labelText: '1',
        color: "rgb(255,245,193)",
      },
      {
        labelText: "1",
        color: "rgb(255,238,155)",
      },
      {
        labelText: "1",
        color: "rgb(255,233,121)",
      },
      {
        labelText: "1",
        color: "rgb(255,226,83)",
      },
      {
        labelText: "1",
        color: "rgb(255,214,42)",
      },
      {
        labelText: "1",
        color: "rgb(242,202,0)",
      },
      {
        labelText: '1',
        color: "rgb(226,188,0)",
      },
    ]
  },
  landQualityYjz: {
    // 标题
    title: "土壤有机质",
    LandLayerShow:true,
    sortDatasetName: "有机质",
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: arr,
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: "getOpt2",
    land_filed: 'organic_matter',
    type: 'class',
    datasetUnit: 'g/kg',
    colorList: [
      {
        labelText: '1',
        color: "rgb(255,251,205)",
      },
      {
        labelText: "1",
        color: "rgb(238,255,165)",
      },
      {
        labelText: "1",
        color: "rgb(220,249,150)",
      },
      {
        labelText: "1",
        color: "rgb(193,239,109)",
      },
      {
        labelText: "1",
        color: "rgb(146,210,90)",
      },
      {
        labelText: "1",
        color: "rgb(116,189,49)",
      },
      {
        labelText: '1',
        color: "rgb(97,156,44)",
      },
    ]
  },
  landQualityPh: {
    // 标题
    title: "pH",
    LandLayerShow:true,
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: arr,
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: "getOpt2",
    type: 'class',
    land_filed: 'p_h',
    colorList: [
      {
        labelText: '1',
        color: "rgb(252, 251, 253)",
      },
      {
        labelText: '1',
        color: "rgb(220, 219, 236)",
      },
      {
        labelText: '1',
        color: "rgb(176, 173, 220)",
      },
      {
        labelText: '1',
        color: "rgb(106, 81, 163)",
      },
      {
        labelText: '1',
        color: "rgb(63, 0, 125)",
      },
    ]
  },
  'buildFacility': {
    // 标题
    title: '建设监管',
    LandLayerShow:true,
    // 单位
    unit: process.env.VUE_APP_AREA_UNIT,
    // 表格列
    columns: [
      { label: '设施编号', field: 'equipNo' },
      { label: '设施类型', field: 'equipType' },
      { label: '地理坐标', field: 'cood' },
      { label: '建设时间', field: 'constructionTime' },
      { label: '设施状态', field: 'equipStatus' },
      { label: '管护人员', field: 'equipPersonnel' },
    ],
    // 图表（1、象形柱图；2、堆叠柱图）
    echart: 'getOpt2',
    iconLegend: [
      {
        labelText: '农田机井',
        num: "101073",
        src: require('@/assets/images/certified/1.png')
      },
      {
        labelText: '农桥',
        num: "101074",
        src: require('@/assets/images/certified/3.png')
      },
      {
        labelText: '沟渠',
        num: "101075",
        src: require('@/assets/images/certified/4.png')
      },
      {
        labelText: '灌溉设备',
        num: "101076",
        src: require('@/assets/images/certified/5.png')
      },
      {
        labelText: '农田气象站',
        num: "101077",
        src: require('@/assets/images/certified/6.png')
      },
      {
        labelText: '虫情测报设备',
        num: "101078",
        src: require('@/assets/images/certified/7.png')
      },
      {
        labelText: '农田监控',
        num: "101079",
        src: require('@/assets/images/certified/7.png')
      }
    ]
  },

  
}
